import { SVGProps, Ref, forwardRef } from 'react';

export const HhProSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M13.91 3.767c.057.201.458 1.595.589 3.053h.012l.03.379a2.78 2.78 0 0 1-.752 2.142c-.584.626-1.42.896-2.305.896H4.52c-.879 0-1.721-.27-2.305-.896A2.81 2.81 0 0 1 1.457 7.2l.03-.38c.139-1.54.578-3.014.596-3.075a.49.49 0 0 1 .367-.33.47.47 0 0 1 .464.162l.385.457c.47.566 1.204.855 1.956.77a2.17 2.17 0 0 0 1.703-1.16l.602-1.186a.48.48 0 0 1 .427-.265H8c.175 0 .343.096.428.265l.601 1.185a2.17 2.17 0 0 0 1.704 1.162 2.22 2.22 0 0 0 1.955-.77l.386-.458a.483.483 0 0 1 .83.168z"
                fill="currentColor"
            />
            <path d="M2.944 10.914a.969.969 0 1 0 0 1.938h10.113a.969.969 0 0 0 0-1.938z" fill="currentColor" />
        </g>
    </svg>
));
HhProSolidSize16Glyph.displayName = 'HhProSolidSize16Glyph';
